import * as React from 'react';
import { observer } from 'mobx-react';
import { Card } from '@/elements/shared/Card/Card';
import Tooltip from '@/ui-kit/components/Tooltip/Tooltip';

import { AttributeCfgUIElement } from '@/elements/attributes/AttributeLayout';
import classNames from 'classnames';
import { BooleanAttributeState } from './BooleanAttributeState';

interface Props {
  state: BooleanAttributeState;
}

export const BooleanAttributeCfgUIElement = observer(function BooleanAttributeCfgUIElement({ state }: Props) {
  const { uiControl } = state.viewElement;
  const itemOptions = uiControl.itemOptions;
  const cardOrientation = uiControl.cardType === 'grid' ? 'vertical' : 'horizontal';
  if (!state.visible) {
    return null;
  }

  return (
    <AttributeCfgUIElement state={state}>
      <ul
        className={classNames('cp-attribute__options', uiControl.cardType === 'grid' && 'cp-attribute__options--card')}
      >
        {state.availableValues.map((value) => {
          const isSelected = state.value === value;
          const text = state.textData.values.find((it) => it.value == value);

          const hasTooltip = itemOptions?.showLongDescription && !!text?.detailedDescription;

          return (
            <li key={String(value)} className={'cp-attribute__option'}>
              <Tooltip disabled={!hasTooltip} title={text?.label ?? ''} description={text?.detailedDescription}>
                {(onOpen) => (
                  <Card
                    orientation={cardOrientation}
                    value={value}
                    onSelect={state.setValue}
                    selected={isSelected}
                    label={itemOptions?.showTitle ? text?.label || (value ? 'yes' : 'no') : ''}
                    imageSrc={itemOptions?.showImage ? text?.image?.url : undefined}
                    imageFit={itemOptions?.imageFit}
                    imageType="icon"
                    description={itemOptions?.showDescription ? text?.description : ''}
                    hasTooltip={hasTooltip}
                    onTooltipClick={onOpen}
                  />
                )}
              </Tooltip>
            </li>
          );
        })}
      </ul>
    </AttributeCfgUIElement>
  );
});
